import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <div className={'footer-container'}>
            <h3>Copyright © {new Date().getFullYear()} ASD Technologies.com, All Rights Reserved.</h3>
        </div>
    );
}

export default Footer;
